import { render, staticRenderFns } from "./message-tasks.vue?vue&type=template&id=36a24d9a&scoped=true"
import script from "./message-tasks.vue?vue&type=script&lang=js"
export * from "./message-tasks.vue?vue&type=script&lang=js"
import style0 from "./message-tasks.vue?vue&type=style&index=0&id=36a24d9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a24d9a",
  null
  
)

export default component.exports